/**
 * iSpeedToClose brand mark — house + upward arrow + speed lines.
 *
 * Visual metaphor: property (roof) + growth (arrow) + velocity (speed lines) =
 * fast deals closing at scale. Compact SVG that inherits `currentColor` for the
 * navy body (adapts to light/dark contexts) with a fixed gold accent for the
 * arrow, speed lines, and window glow.
 *
 * File name is legacy — the component is imported in ~50 places and renaming
 * everything is more churn than value. The export is still the canonical
 * brand mark used across the entire UI.
 */
export default function AssignFlowLogo({ size = 16, accent = "#F59E0B", className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="iSpeedToClose"
      role="img"
      className={className}
    >
      {/* Arcing swoosh (partial dial) — currentColor */}
      <path
        d="M6 12 A 6 6 0 0 1 18 8"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        fill="none"
      />
      {/* Roof — currentColor */}
      <path
        d="M5 17 L 12 9 L 19 17"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
      />
      {/* Roof floor line — currentColor */}
      <path
        d="M5.5 17 L 18.5 17"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      {/* Window inside house — gold accent */}
      <rect x="10.5" y="13" width="3" height="3" fill={accent} rx="0.4" />
      {/* Upward arrow rising through the roof — gold accent */}
      <path
        d="M15 5.2 L 17.6 3.4 L 17.6 7 M 17.6 3.4 L 12 11"
        stroke={accent}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Speed lines to the left — gold accent */}
      <path d="M1.5 11 L 4.5 11" stroke={accent} strokeWidth="1.4" strokeLinecap="round" />
      <path d="M1 13.5 L 4 13.5" stroke={accent} strokeWidth="1.4" strokeLinecap="round" />
      <path d="M1.5 16 L 4.5 16" stroke={accent} strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}
